import { useQuery } from "react-query";
import { fetchActionCenter } from "@/services/tasks";
/** Query hook for the action center data of a specific reminder. */
export function useActionCenter(patientUid, reminderId) {
  return useQuery(["action-center", patientUid, reminderId], function () {
    return fetchActionCenter(patientUid, reminderId);
  }, {
    enabled: Boolean(patientUid) && Boolean(reminderId)
  });
}